import { Component, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TemplatesComponent } from '../../templates.component';

export interface AddTemplateData {
  name: string;
}

@Component({
    selector: 'app-add-template',
    templateUrl: './add-template.dialog.html',
    styleUrls: ['./add-template.dialog.sass'],
    standalone: false
})

export class AddTemplateDialog {

  constructor(
    public dialogRef: MatDialogRef<TemplatesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddTemplateData,
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

}
